import { IShopSearchResultsAction, IShopSearchResultsData } from 'models/search/shopsearchresults';
import { IShopListItem } from 'models/shop/shoplistitem';
import { IStore } from 'redux/IStore';
import { IPage } from 'models/common';
import { IShopCard } from '../../../../models/shop/shopcard';
import { getFollowingOrFollowersButtonsData } from 'redux/modules/user/usercard';

/** Action Types */
export const REQUEST_START: string = 'shopssearchresults/REQUEST_START';
export const REQUEST_FAILURE: string = 'shopssearchresults/REQUEST_FAILURE';
export const GET_SHOPS_SUCCESS: string = 'shopssearchresults/GET_ARTICLES_SUCCESS';
export const SET_ITEMS_PAGE: string = 'shopssearchresults/SET_ITEMS_PAGE';
export const SET_USER_ID: string = 'shopssearchresults/SET_USER_ID';
export const RESET_DATA: string = 'shopssearchresults/RESET_DATA';
export const LIKE_ITEM_SUCCESS: string = 'shopssearchresults/LIKE_ITEM_SUCCESS';
export const SET_LAST_SEARCHED_KEYWORD: string = 'shopssearchresults/SET_LAST_SEARCHED_KEYWORD';
export const RESET_FILTERS: string = 'shopssearchresults/RESET_FILTERS';
export const SET_LANGUAGE_FILTER: string = 'shopssearchresults/SET_LANGUAGE_FILTER';
export const GET_SELECTED_SEARCHED_SHOP_SUCCESS: string = 'shopssearchresults/GET_SELECTED_SEARCHED_SHOP_SUCCESS';
export const TOGGLE_FILTERS: string = 'shopssearchresults/TOGGLE_FILTERS';

/** Initial State */
const initialState: IShopSearchResultsData = {
	items: [],
	isFetching: false,
	itemsPage: {
		currentPage: 0,
		totalPages: 0,
		totalItems: 0,
		itemsPerPage: 10,
		items: [],
	},
	userId: null,
	lastSearchedKeyword: null,
	sortOrder: null,
	queryType: null,
	selectedSearchedShop: null,
	filterDrawerOpen: false,
};

/** Reducer */
export function shopSearchResultsReducer(state = initialState, action: IShopSearchResultsAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
				error: false,
			});

		case GET_SHOPS_SUCCESS:
			return Object.assign({}, state, {
				items: action.payload.items,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				isFetching: false,
				message: action.payload.message,
				error: true,
			});

		case SET_ITEMS_PAGE:
			return Object.assign({}, state, {
				itemsPage: action.payload.itemsPage,
			});

		case RESET_DATA:
			return Object.assign({}, state, {
				items: [],
				itemsPage: {
					currentPage: 0,
					totalPages: 0,
					totalItems: 0,
					itemsPerPage: 10,
					items: [],
				},
				userId: null,
				selectedSearchedShop: null,
			});

		case LIKE_ITEM_SUCCESS:
			return Object.assign({}, state, {
				isFetching: false,
			});

		case SET_USER_ID:
			return Object.assign({}, state, {
				userId: action.payload.userId,
			});

		case SET_LAST_SEARCHED_KEYWORD:
			return Object.assign({}, state, {
				lastSearchedKeyword: action.payload.lastSearchedKeyword,
			});

		case GET_SELECTED_SEARCHED_SHOP_SUCCESS:
			return Object.assign({}, state, {
				selectedSearchedShop: action.payload.selectedSearchedShop,
				isFetching: false,
			});

		case TOGGLE_FILTERS:
			return Object.assign({}, state, {
				filterDrawerOpen: !state.filterDrawerOpen,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function getShopSearchResults(isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetData());
		}

		dispatch(requestStart());

		const currentPage: number = getState().shopSearchResults.itemsPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().shopSearchResults.itemsPage.itemsPerPage;

		let queryString = '?';
		if (keyword) {
			queryString = queryString + 'keyword=' + keyword;
		}
		queryString += '&CurrentPage=' + newPage;
		queryString += '&ItemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/Search' + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						if (isFirstLoad) {
							dispatch(resetData());
						}
						const shopSearchResultsState: IShopSearchResultsData = getState().shopSearchResults;
						const items: IShopListItem[] = shopSearchResultsState.items;
						const newItems: IShopListItem[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getFollowingOrFollowersButtonsData(items, true, false));
						dispatch(getShopsSuccess(items));
						dispatch(setItemsPage(res));
						dispatch(setLastSearchedKeyword(keyword));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getSelectedSearchedShop(id: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/Shop/' + id,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IShopCard) => {
						dispatch(getSelectedSearchedShopSuccess(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IShopSearchResultsAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function getShopsSuccess(items: IShopListItem[]): IShopSearchResultsAction {
	return {
		type: GET_SHOPS_SUCCESS,
		payload: {
			items,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IShopSearchResultsAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function setItemsPage(itemsPage: IPage): IShopSearchResultsAction {
	return {
		type: SET_ITEMS_PAGE,
		payload: {
			itemsPage,
		},
	};
}

/** Action Creator */
export function resetData(): IShopSearchResultsAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function setUserId(userId: string): IShopSearchResultsAction {
	return {
		type: SET_USER_ID,
		payload: {
			userId,
		},
	};
}

/** Action Creator */
export function setLastSearchedKeyword(lastSearchedKeyword: string): IShopSearchResultsAction {
	return {
		type: SET_LAST_SEARCHED_KEYWORD,
		payload: {
			lastSearchedKeyword,
		},
	};
}

/** Action Creator */
export function getSelectedSearchedShopSuccess(selectedSearchedShop: IShopCard): IShopSearchResultsAction {
	return {
		type: GET_SELECTED_SEARCHED_SHOP_SUCCESS,
		payload: {
			selectedSearchedShop,
		},
	};
}

/** Action Creator */
export function toggleProductFilter(): IShopSearchResultsAction {
	return {
		type: TOGGLE_FILTERS,
	};
}
